<!-- =========================================================================================
    File Name: KnowledgeBase.vue
    Description: Knowledge Base Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="scrollable-div">
    <!-- JUMBOTRON -->
    <div class="knowledge-base-jumbotron" v-if="selectedIndex == -1">
      <div
        class="knowledge-base-jumbotron-content lg:p-32 md:p-24 sm:p-16 p-8 rounded-lg mb-base"
      >
        <h1 class="mb-1 text-white">Public Vessel Tracking</h1>
        <p class="text-white">Use the filters to find vessels easily.</p>
        <vs-input
          icon-no-border
          placeholder="Search by Vessel Name"
          v-model="vesselBaseSearchQuery"
          icon-pack="feather"
          icon="icon-search"
          size="large"
          class="w-full mt-6"
        />
        <br />
        <!-- <vs-row>
          <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="4">
            <vs-select class="selectExample" placeholder="Filter by Operator">
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.label"
                v-for="(item, index) in operator"
              />
            </vs-select>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="4">
            <vs-select class="selectExample" placeholder="Filter by Status">
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.label"
                v-for="(item, index) in status"
              />
            </vs-select>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="4">
            <vs-select class="selectExample" placeholder="Filter by Atoll">
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.label"
                v-for="(item, index) in atoll"
              />
            </vs-select>
          </vs-col>
        </vs-row> -->
      </div>
    </div>

    <!-- KNOWLEDGE BASE CARDS  -->
    <div class="vx-row" v-if="selectedIndex == -1">
      <div
        class="vx-col w-full md:w-1/4 sm:w-1/2 mb-base"
        v-for="(item, index) in filteredKB"
        :key="item.id"
      >
        <vx-card class="text-center cursor-pointer">
          <img
            :src="item.coverImageUrl"
            alt="graphic"
            width="250"
            class="mx-auto mb-4"
          />
          <h4 class="mb-2">{{ item.assetName.toUpperCase() }}</h4>
          <small>{{ 'Last Updated : ' + item.lastUpdated }}</small
          ><br />
          <small class="text-success" v-if="item.status == 'Moving'">{{
            'Ongoing Trip'
          }}</small>
          <small class="text-primary" v-if="item.status == 'Parked'">{{
            'Docked'
          }}</small>
          <small class="text-warning" v-if="item.status == 'Idling'">{{
            'Idling'
          }}</small>
          <!-- <small class="text-danger" v-if="item.status == ''">{{
            'Emergency'
          }}</small> -->
          <small class="text-primary">
            - {{ item.address }}</small
          ><br />
          <vs-row>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="4"
            >
              <vs-list-item
                icon="store"
                :subtitle="item.operator"
              ></vs-list-item>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="4"
            >
              <vs-list-item icon="phone" :subtitle="item.phone"></vs-list-item>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="4"
            >
              <vs-list-item
                icon="directions_boat"
                :subtitle="item.category"
              ></vs-list-item>
            </vs-col>
          </vs-row>
          <Detail
      :data="item"
    ></Detail>
        </vx-card>
      </div>
    </div>


  </div>
</template>

<script>
import vSelect from 'vue-select';
import Detail from './Detail.vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import axios from '@/axios.js';

export default {
  data() {
    return {
      selectedIndex: -1,
      state: 'list',
      vessels:[],
      operator: [
        {
          value: 'Igeotech Pvt Ltd',
          label: 'Igeotech Pvt Ltd',
        },
        {
          value: 'Sunrise Tech Pvt Ltd',
          label: 'Sunrise Tech Pvt Ltd',
        },
        {
          value: 'Maldives Pvt Ltd',
          label: 'Maldives Pvt Ltd',
        },
      ],
      atoll: [
        {
          value: 'Haa Alif',
          label: 'Haa Alif',
        },
        {
          value: 'Noonu',
          label: 'Noonu',
        },
        {
          value: 'Haa Dhalu',
          label: 'Haa Dhalu',
        },
        {
          value: 'Shaviyani',
          label: 'Shaviyani',
        },
        {
          value: 'Raa',
          label: 'Raa',
        },
        {
          value: 'Baa',
          label: 'Baa',
        },
        {
          value: 'Meemu',
          label: 'Meemu',
        },
        {
          value: 'Tha',
          label: 'Tha',
        },
        {
          value: 'Faafu',
          label: 'Faafu',
        },
        {
          value: 'Laamu',
          label: 'Laamu',
        },
      ],
      status: [
        {
          value: 0,
          label: 'Ongoing Trip',
        },
        {
          value: 1,
          label: 'Docked',
        },
        {
          value: 2,
          label: 'Require Assistance',
        },
        {
          value: 4,
          label: 'Emergency',
        },
      ],
      vesselBaseSearchQuery: ''
    };
  },
  methods: {
    changeIndex(index) {
      this.selectedIndex = index;
    },
    handleDataFromChild() {
      this.selectedIndex = -1;
    },
    getData() {
      const self = this;
      axios
        .post(
          `https://api.igeotechgps.com/api-vms/public-get-units`,
          {},
        )
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
          console.log(response.data.unitDetails)
          self.vessels = response.data.unitDetails;
          //  console.log(self.templateData)
          } else if (response.data.error) {
          } else {
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

  },
  computed: {
    filteredKB() {
      return this.vessels.filter((item) =>
        item.assetName
          .toLowerCase()
          .includes(this.vesselBaseSearchQuery.toLowerCase()),
      );
    },
  },
  components: {
    vSelect,
    Detail,
    VuePerfectScrollbar,
    axios
  },
  mounted() {
    const self = this;
    self.getData()
  }
};
</script>

<style lang="scss">
.knowledge-base-jumbotron-content {
  background-image: url('../../../assets/images/pages/knowledge-base-cover.jpg');
  background-size: cover;
}

.scrollable-div {
  height: 99vh;
  /* Set the height of the div */
  overflow-y: scroll;
  /* Enable vertical scrolling */
}

</style>
